<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height class="px-0 py-0">
        <v-row style="height: 100%;">
          <v-col cols="5" v-show="!$orientation.portrait" class="hidden-sm-and-down" style="background-color: #546E7A;">
            <v-container fill-height>
              <v-card flat tile dark color="transparent" class="mx-6">
                <img src="@/assets/stamp-white.png" width="30%" class="mx-4 my-6" />
                <v-card-subtitle class="display-1 font-weight-bold my-6">Construa conosco a agropecuária do futuro</v-card-subtitle>
                <v-card-subtitle class="title">Plataforma de desenvolvimento de ativos digitais da Embrapa: aprenda, colabore, desenvolva e distribua as soluções digitais do agro sustentável!</v-card-subtitle>
              </v-card>
            </v-container>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.smAndDown || $orientation.portrait ? '12' : '7'">
            <v-container fill-height justify-center>
              <v-card flat tile color="transparent" width="500px" class="mx-6">
                <v-chip x-large color="pink darken-1" label text-color="white" class="mb-8">
                  <v-icon x-large start class="mr-2">admin_panel_settings</v-icon>
                  Painel de Gestão
                </v-chip>
                <img src="@/assets/embrapa.io.png" width="100%" />
                <v-alert type="error" icon="warning" :value="error" transition="scale-transition" class="mx-0 my-0">
                  {{ message }}
                </v-alert>
                <v-window v-model="step">

                  <v-window-item>
                    <v-card-subtitle class="title px-0">Para começar, digite seu e-mail abaixo:</v-card-subtitle>
                    <v-form ref="form" lazy-validation>
                      <v-text-field
                        v-model="email"
                        append-icon="mail"
                        outlined
                        clearable
                        label="e-Mail"
                        type="text"
                        :rules="rules"
                      />

                      <v-radio-group v-model="reliable" :row="!$vuetify.breakpoint.xsOnly" class="pa-0 ma-0">
                        <template v-slot:label>
                          <div>Este dispositivo é <strong>confiável</strong>?</div>
                        </template>
                        <v-radio
                          label="Sim"
                          :value="true"
                        />
                        <v-radio
                          label="Não"
                          :value="false"
                        />
                        <template v-slot:append>
                          <v-btn text icon small @click="reliableInfo()">
                            <v-icon>help</v-icon>
                          </v-btn>
                        </template>
                      </v-radio-group>
                    </v-form>
                    <v-btn color="success" x-large block @click="sendPin()" :disabled="!validate()" :loading="loading">
                      <v-icon class="mr-2">
                        pin
                      </v-icon>
                      Usar PIN numérico
                      <v-icon class="ml-2">
                        arrow_forward
                      </v-icon>
                    </v-btn>

                    <v-divider class="my-4" />

                    <v-btn
                      v-if="passkeyAvailable"
                      color="primary"
                      outlined
                      x-large
                      block
                      @click="loginWithPasskey()"
                      :loading="passkeyLoading"
                      :disabled="!email || email.length === 0 || reliable === null"
                    >
                      <v-icon class="mr-2">
                        fingerprint
                      </v-icon>
                      Usar Biometria (Passkey)
                    </v-btn>
                  </v-window-item>

                  <v-window-item>
                    <v-card-subtitle class="title px-0">Um número de 6 dígitos foi enviado para o e-mail <strong>{{ email }}</strong>. Para continuar, insira-o abaixo:</v-card-subtitle>
                    <div class="input-wrapper mb-3" style="width: 280px; margin: 0 auto;">
                      <v-otp-input v-model="pin" length="6" @finish="authenticate()" />
                    </div>
                    <v-card-text v-if="step == 1 && needPrivacy()" class="mt-6 mb-0 py-0">
                      <v-btn color="purple" outlined large @click="showPrivacy()" block>
                        <v-icon class="mr-2">
                          gavel
                        </v-icon>
                        Política de Privacidade
                      </v-btn>
                      <v-switch v-model="agree" label="Li e aceito os termos." class="mt-3 mx-2" />
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="success"
                        depressed
                        :disabled="pin.length !== 6 || (needPrivacy() && !agree)"
                        x-large
                        @click="authenticate()"
                        block
                        :loading="loading"
                      >
                        Autenticar
                        <v-icon class="ml-2">
                          done
                        </v-icon>
                      </v-btn>
                    </v-card-actions>
                    <v-card-actions>
                      <v-btn
                        color="error"
                        text
                        @click="cancel()"
                        block
                      >
                        Cancelar
                      </v-btn>
                    </v-card-actions>
                  </v-window-item>

                </v-window>
              </v-card>
            </v-container>
            <v-footer absolute padless color="rgba(255,255,255,0)">
              <v-col :class="$vuetify.breakpoint.smAndDown || $orientation.portrait ? 'text-center' : 'text-right'">
                <v-chip label color="blue-grey lighten-4" text-color="white">
                  <v-icon class="mr-1">
                    update
                  </v-icon>
                  Versão {{ version }}
                </v-chip>
              </v-col>
            </v-footer>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <dialog-wrapper @consent="agree = true" @dissent="agree = false" ref="dPrivacy" />
    <dialog-wrapper ref="dReliable" />
    <passkey-setup ref="passkeySetup" @close="onPasskeySetupClose" />
    <beta-wrapper />

    <!-- Snackbar para mensagens de sucesso -->
    <v-snackbar v-model="snackbar" :timeout="5000" color="success" top>
      <v-icon class="mr-2">check_circle</v-icon>
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import axios from 'axios'
import md5 from 'crypto-js/md5'

import EmbrapaHelper from '@/helpers/embrapa'
import ErrorHelper from '@/helpers/error'
import PasskeyHelper from '@/helpers/passkey'

import DialogWrapper from '@/components/DialogDefault'
import BetaWrapper from '@/components/BetaRelease'
import PasskeySetup from '@/components/PasskeySetup'
import { startAuthentication } from '@simplewebauthn/browser'

const pkg = require('../../package.json')

export default {
  mixins: [
    EmbrapaHelper,
    ErrorHelper,
    PasskeyHelper
  ],
  components: {
    DialogWrapper,
    BetaWrapper,
    PasskeySetup
  },
  data: () => ({
    step: 0,
    email: '',
    rules: [
      v => !v || /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(v) || 'O e-mail precisa ser válido!'
    ],
    pin: '',
    privacy: null,
    agree: false,
    reliable: null,
    loading: false,
    passkeyLoading: false,
    passkeyAccountIds: [],
    passkeyAvailable: false, // Verifica se dispositivo suporta biometria
    wait: false,
    error: false,
    message: '',
    version: pkg.version,
    snackbar: false,
    snackbarMessage: ''
  }),
  async mounted () {
    // Verifica se o dispositivo suporta autenticadores de plataforma (biometria)
    await this.checkPasskeyAvailability()

    const user = this.$localStorage.get('user')

    // Só redireciona se o usuário estiver autenticado E tiver token válido
    if (user && user.authenticated && user.token) {
      this.$router.replace({ path: '/home' }).catch(() => {})
    } else {
      // Se não está autenticado, verifica se tem email salvo
      const email = this.$localStorage.get('email')

      if (email && email.length > 0) {
        this.reliable = true
        this.email = email
        this.step = 1
      }
    }
  },
  methods: {
    async checkPasskeyAvailability () {
      try {
        // Verifica se o navegador suporta WebAuthn
        if (!window.PublicKeyCredential) {
          this.passkeyAvailable = false
          return
        }

        // Verifica se há autenticador de plataforma disponível (Touch ID, Face ID, Windows Hello, etc)
        // eslint-disable-next-line no-undef
        const available = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
        this.passkeyAvailable = available
      } catch (err) {
        console.error('[Passkey] Erro ao verificar disponibilidade:', err)
        this.passkeyAvailable = false
      }
    },
    needPrivacy () {
      return !this.isEmbrapa(this.email)
    },
    showPrivacy () {
      const self = this
      axios.get('/privacy-policy.html').then(pol => {
        self.privacy = pol.data
        self.$refs.dPrivacy.open('Política de Privacidade', self.privacy, 'Aceito', 'Não Aceito')
      })
    },
    reliableInfo () {
      const text = '<p>Um <strong>dispositivo confiável</strong> é um equipamento de <u>uso não compartilhado</u> (p.e., <strong>seu celular ou computador pessoal</strong>). Neste caso você permanecerá autenticado neste dispositivo por <u>tempo indeternimado</u>.</p>' +
        '<p>Caso esteja em um equipamento de uso compartilhado, tal como o computador de um saguão de hotel, marque <strong>NÃO</strong> nesta opção! Com isso, ao fechar o navegador, seu usuário será automaticamente deslogado.</p>'

      this.$refs.dPrivacy.open('Dispositivo Confiável', text, 'Ok')
    },
    validate () {
      return this.$refs.form && this.$refs.form.validate() && this.reliable !== null
    },
    cancel () {
      this.$localStorage.set('email', '')

      this.error = false
      this.message = ''

      this.agree = false

      this.email = ''
      this.reliable = null

      this.pin = ''

      this.loading = false

      this.step = 0
    },
    sendPin () {
      this.error = false

      if (!navigator.onLine) {
        this.message = 'É necessário uma conexão com a internet para prosseguir! Por favor, verifique suas configurações de rede ou tente novamente mais tarde.'

        this.error = true

        return
      }

      const err = error => {
        this.loading = false

        this.message = this.errorMessage(error)

        this.error = true
      }

      this.loading = true

      const api = process.env.VUE_APP_API

      axios.get(api + '/status', { timeout: 12000 }).then(response => {
        axios.post(api + '/pin', { email: this.email, reliable: this.reliable }).then(response => {
          if (this.reliable) this.$localStorage.set('email', this.email)

          this.loading = false

          this.step++
        }).catch(err)
      }).catch(err)
    },
    authenticate () {
      if (this.pin.length !== 6 || (this.needPrivacy() && !this.agree)) return

      this.error = false

      if (!navigator.onLine) {
        this.message = 'É necessário uma conexão com a internet para prosseguir! Por favor, verifique suas configurações de rede ou tente novamente mais tarde.'

        this.error = true

        return
      }

      const err = error => {
        this.loading = false

        this.message = this.errorMessage(error)

        this.error = true
      }

      this.loading = true

      const api = process.env.VUE_APP_API

      axios.get(api + '/status', { timeout: 12000 }).then(response => {
        axios.post(api + '/authenticate', { email: this.email, pin: this.pin, reliable: this.reliable }).then(response => {
          const token = response.data.token

          axios.get(api + '/manager', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
            const user = {
              authenticated: true,
              name: response.data.name,
              email: response.data.email,
              role: response.data.role,
              picture: '',
              token
            }

            const picture = 'https://www.gravatar.com/avatar/' + md5(response.data.email).toString() + '?s=200&d=404'

            axios.get(picture).then(response => {
              user.picture = picture
            }).finally(async () => {
              this.$localStorage.set('user', user)
              this.$localStorage.set('reliable', this.reliable)

              this.$localStorage.set('email', '')

              // Verificar se usuário tem passkeys registradas antes de navegar
              await this.checkAndOfferPasskeySetup(user.token)

              this.$router.replace({ path: '/home' }).catch(() => {})
            })
          }).catch(err)
        }).catch(err)
      }).catch(err)
    },
    async checkAndOfferPasskeySetup (token) {
      try {
        // Só oferece passkey se biometria estiver disponível
        if (!this.passkeyAvailable) {
          return
        }

        const api = process.env.VUE_APP_API
        const res = await axios.get(api + '/passkey/list', {
          headers: { Authorization: 'Bearer ' + token }
        })

        const accountIds = (res.data.passkeys || []).map(pk => pk.id)

        // Convida quem ainda não tem credencial NESTE aparelho — a biometria é
        // criada por autenticador, e a do computador não serve no celular. Quem
        // recusou fica em paz enquanto suas credenciais não mudarem.
        if (!this.passkeyRegisteredHere(accountIds) && !this.passkeyDeclined(accountIds)) {
          this.passkeyAccountIds = accountIds

          // Pequeno delay para garantir que o modal renderize
          await new Promise(resolve => setTimeout(resolve, 300))

          if (this.$refs.passkeySetup) {
            this.$refs.passkeySetup.open()

            // Aguardar o modal fechar antes de continuar
            await new Promise(resolve => {
              const checkClose = () => {
                if (!this.$refs.passkeySetup.dialog) {
                  resolve()
                } else {
                  setTimeout(checkClose, 100)
                }
              }
              checkClose()
            })
          }
        }
      } catch (err) {
      }
    },
    onPasskeySetupClose (success, failed) {
      // Recusar é uma decisão; falhar, não. Só a recusa suspende o convite, e
      // ainda assim apenas enquanto as credenciais da conta seguirem as mesmas.
      if (!success && !failed) {
        this.passkeyDecline(this.passkeyAccountIds)
      }

      if (success) {
        // Usa sessionStorage para mostrar mensagem após navegar
        window.sessionStorage.setItem('showPasskeySuccess', 'true')
      }
    },
    async loginWithPasskey () {
      if (!this.email || this.email.length === 0) {
        this.message = 'Digite seu e-mail primeiro'
        this.error = true
        return
      }

      if (this.reliable === null) {
        this.message = 'Selecione se este dispositivo é confiável'
        this.error = true
        return
      }

      this.passkeyLoading = true
      this.error = false

      const err = error => {
        this.passkeyLoading = false

        if (error.name === 'NotAllowedError') {
          this.message = 'Operação cancelada ou não autorizada pelo navegador.'
        } else if (error.name === 'NotSupportedError') {
          this.message = 'Seu navegador ou dispositivo não suporta Passkeys.'
        } else if (error.response?.data?.code === 'NO_PASSKEYS_REGISTERED') {
          this.message = 'Você ainda não registrou nenhuma Passkey. Faça login com PIN primeiro.'
        } else {
          this.message = this.errorMessage(error)
        }

        this.error = true
      }

      try {
        const api = process.env.VUE_APP_API

        // 1. Obter options do servidor
        const optionsRes = await axios.post(api + '/passkey/login-options', {
          email: this.email
        })

        // 2. Iniciar autenticação (navegador exibe prompt de biometria)
        // Na v13+, usar { optionsJSON: opts } conforme documentação oficial
        const asseResp = await startAuthentication({ optionsJSON: optionsRes.data })

        // 3. Enviar credencial para servidor verificar e obter JWT
        const verifyRes = await axios.post(api + '/passkey/login-verify', {
          email: this.email,
          response: asseResp,
          reliable: this.reliable
        })

        const token = verifyRes.data.token

        // 4. Obter dados do usuário e fazer login
        const userRes = await axios.get(api + '/manager', { headers: { Authorization: 'Bearer ' + token } })

        const user = {
          authenticated: true,
          name: userRes.data.name,
          email: userRes.data.email,
          role: userRes.data.role,
          picture: '',
          token
        }

        const picture = 'https://www.gravatar.com/avatar/' + md5(userRes.data.email).toString() + '?s=200&d=404'

        try {
          await axios.get(picture)
          user.picture = picture
        } catch (e) {
          user.picture = ''
        }

        this.$localStorage.set('user', user)
        this.$localStorage.set('reliable', this.reliable)

        this.$router.replace({ path: '/home' }).catch(() => {})
      } catch (error) {
        console.error('[Passkey Login] Error:', error)

        if (error.response) {
          console.error('[Passkey Login] Response error:', error.response.status, error.response.data)
        }

        err(error)
      } finally {
        this.passkeyLoading = false
      }
    }
  }
}
</script>
